<template>
    <v-card class="pa-4">
        <v-card-title class="headline px-0 mb-2 py-0">New Student</v-card-title>
        <v-form ref="form">
            <v-text-field
                autocomplete="new-password"
                label="Name"
                v-model="student.engName"
                ref="engName"
                :rules="required"
            ></v-text-field>
            <v-text-field
                autocomplete="new-password"
                label="Hebrew Name"
                v-model="student.hebName"
                ref="hebName"
                :rules="required"
            ></v-text-field>
            <v-combobox
                autocomplete="new-password"
                :items="schools"
                label="School"
                v-model="student.school"
                ref="school"
                :rules="required"
            ></v-combobox>
            <v-text-field
                autocomplete="new-password"
                label="Section"
                v-model="student.section"
                ref="section"
            ></v-text-field>
            <v-text-field
                autocomplete="new-password"
                label="Teacher Name"
                v-model="student.teacherName"
                ref="teacherName"
            ></v-text-field>
            <v-text-field
                autocomplete="new-password"
                label="Teacher Number"
                v-model="student.teacherNumber"
                ref="teacherNumber"
                :mask="phoneMask"
            ></v-text-field>
            <v-menu
                v-model="datePickerMenu"
                :close-on-content-click="false"
                full-width
                max-width="290"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        :value="formatedDate"
                        label="Date Of Birth"
                        v-on="on"
                        ref="dob"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="student.dob"
                    @change="datePickerMenu = false"
                ></v-date-picker>
            </v-menu>
            <v-autocomplete
                autocomplete="new-password"
                label="Class"
                v-model="student.class"
                ref="class"
                :rules="required"
                :items="
                    gradesSetup
                        .filter((g) => g.isGirlsCampAvail)
                        .map((g) => g.grade)
                "
            ></v-autocomplete>
        </v-form>
        <v-card-actions class="mr-0 mt-2">
            <v-spacer></v-spacer>
            <v-btn color="default" dark @click="closeNewStudentModal()"
                >Cancel</v-btn
            >
            <v-btn color="success" @click="save">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import moment from "moment";

export default {
    props: {
        gradesSetup: Array,
        closeNewStudentModal: Function,
        onCreated: Function,
        account: Object,
        studentToEdit: Object,
        refresh: Function,
    },
    data() {
        return {
            student: {
                studentID: "",
                hebName: "",
                engName: "",
                dob: "",
                class: "",
                familyID: "",
                school: "",
                teacherNumber: "",
                teacherName: "",
                section: "",
            },

            phoneMask: "###-###-####",

            processing: false,
            datePickerMenu: false,

            schools: [],

            required: [(value) => !!value || "Required."],
        };
    },
    async created() {
        await this.loadSchools();
    },
    watch: {
        studentToEdit(newValue) {
            if (!newValue) return;

            this.prefill(newValue);
        },
    },
    computed: {
        formatedDate() {
            return this.student.dob ? moment(this.student.dob).format("L") : "";
        },
    },
    methods: {
        async loadSchools() {
            const schools = await this.$http.get("api/girlscamp/getSchoolList");

            this.schools = schools;
        },
        prefill(student) {
            if (!student || !student.studentID) return;

            this.student.studentID = student.studentID;
            this.student.hebName = student.hebName;
            this.student.engName = student.engName;
            this.student.school = student.school;
            this.student.section = student.section;
            this.student.teacherName = student.teacherName;
            this.student.teacherNumber = student.teacherNumber;
            this.student.dob = new Date(student.dob)
                .toISOString()
                .substr(0, 10);
            this.student.class = student.class;
        },
        clear() {
            this.student.hebName = "";
            this.student.engName = "";
            this.student.school = "";
            this.student.section = "";
            this.student.teacherName = "";
            this.student.teacherNumber = "";
            this.student.dob = "";
            this.student.class = "";
            this.student.familyID = "";
        },
        async save() {
            if (!this.student.dob) {
                this.$notify({
                    text: "Missing Date Of Birth",
                    group: "notification",
                    type: "error",
                });

                return;
            }
            if (!moment(this.student.dob).isValid()) {
                this.$notify({
                    text: "Invalid Date",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (!this.$refs.form.validate(true)) return;

            this.processing = true;

            this.student.familyID = this.account.accountID;

            try {
                const student = await this.$http.post(
                    "api/lapidusDayCamp/saveNewStudent?user=" +
                        this.$store.state.authentication.user +
                        "&prefix=XGC",
                    this.student
                );

                this.onCreated(student);

                this.clear();

                this.processing = false;

                if (this.refresh) {
                    this.refresh();
                }
            } catch (e) {
                this.processing = false;

                return;
            }
        },
    },
};
</script>
